<adapt-strategy-board-agenda-item *adaptIfAuthorised="EditBullseye; else featureNotEnabled"
                                  [pageActivationTours]="pageActivationTours"
                                  buttonText="Attach bullseye inputs"></adapt-strategy-board-agenda-item>

<ng-template #featureNotEnabled>
    <span>This feature is enabled only for the Growth+ platform subscription.</span>
</ng-template>
